import React from 'react';


const TestimonialsPage = () => {
  return (
    <>
     
    </>
  );
};

export default TestimonialsPage;
